// extracted by mini-css-extract-plugin
module.exports = {"content":"_b47b830","icon":"_a57ec30","deductionMessage":"_3d5d2b9"};